import { atom } from 'jotai';

export const bookingActionDoneAtom = atom(false);
